module.exports = __webpack_public_path__ + "media/images/company/cp21-b65bc87c4a1373c748ab77fd5c6b30c3.png";